/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}                from '@/util/i.command';
import {
  WorkBlock
}                                from '@/models/scenario/work.block';
import {WorkBlockChange}         from '@/screens/ide/workblox/work.block.change';
import {WorkBloxEditorComponent} from '@/components/work.blox.editor.component';
import {Logger}                  from '@/util/logger';

/**
 *
 * @class AddWorkBlockCommand
 *
 * @brief reversible addition of a work block
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class AddWorkBlockCommand implements ICommand {

  private newValue: WorkBlockChange         = null;
  private   editor: WorkBloxEditorComponent = null;
  private newBlock: WorkBlock               = null;

    constructor(newValue: WorkBlockChange, editor: WorkBloxEditorComponent) {

    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    /* assign id/create the new work block */

    if (this.newBlock == null) {

      const input: WorkBlockChange = this.newValue.snapshot;
      const    id: number          = this.editor.scenario.allocateWorkBlockId();

      this.newBlock                = new WorkBlock(
        id,
        input.start,
        input.end,
        input.days,
        input.begin.asSeconds(),
        input.duration.asSeconds(),
        input.type,
        input.name,
        input.description,
        -1
      );
    }

    Logger.debug('[workblox/table:add] saving ', this.newBlock);

    /* save it to the scenario */

    this.editor.scenario.workBlocks().set(this.newBlock._id, this.newBlock);

    /* refresh the views */

    this.editor.table.refreshTable();
    this.editor.graph.refreshGraph();

    Logger.debug('[workblox/table:add] refreshed.');

    /* clear the view selections */

    this.editor.table.doSelection(null);
    this.editor.graph.doSelection(null);
    this.editor.editor.clear();

    Logger.debug('[workblox/table:add] selection cleared.');
  }

  /** reverse the command's effects */
  unExecute() {

    /* delete the block that was added */

    Logger.debug('[workblox/table:add] deleting ', this.newBlock);

    this.editor.scenario.workBlocks().delete(this.newBlock._id);

    /* refresh the views (so the block disappears) */

    this.editor.table.refreshTable();
    this.editor.graph.refreshGraph();

    Logger.debug('[workblox/table:add] refreshed.');

    /*
     * (re)select what was selected when we added, this brings back the
     * selection, and the the edit inputs as they were just before the
     * add.
     *
     */

    this.editor.table.doSelection(this.newValue);

  }

  /** return a string summary of this command */
  asString(): string {

    const b = (this.newValue instanceof WorkBlockChange) ? this.newBlock._id : '';

    return '[workblox/table:add] ' + b;
  }

}
